// QG-CLI-PAGES-013: `Organizations.tsx` and `OrganizationDetailPage.tsx` used to
// each define byte-identical `STATUS_CLASSES`/`PLAN_CLASSES` maps (with the
// `enterprise` entry hardcoded to raw Tailwind palette classes — QG-CLI-PAGES-014).
// Single source of truth here, backed by the shared `<Badge>` component's
// semantic variants so both surfaces stay in sync and themed correctly.
import type { BadgeVariant } from '../../components/ui/Badge.js';

/** Badge variant for an organization's `status` column. Unrecognized/missing → 'active'. */
export function orgStatusBadgeVariant(status: string | null | undefined): BadgeVariant {
  switch (status) {
    case 'suspended':
      return 'danger';
    case 'archived':
      return 'neutral';
    default:
      return 'success'; // 'active' and any unrecognized value
  }
}

/** Badge variant for an organization's `plan` column. Unrecognized/missing → 'free'. */
export function orgPlanBadgeVariant(plan: string | null | undefined): BadgeVariant {
  switch (plan) {
    case 'standard':
      return 'accent';
    case 'enterprise':
      return 'purple';
    default:
      return 'neutral'; // 'free' and any unrecognized value
  }
}
